module.exports = __webpack_public_path__ + "static/media/namtip.992fadec.png";